<template>
    <component :is="layout">
        <slot />
    </component>
</template>

<script>
import LayoutDefault from '@/components/Layout/LayoutDefault.vue'
import { shallowRef, watch } from 'vue'
import { useRoute } from 'vue-router'
export default {
    name: 'LayoutContainer',
    setup() {
        const layout = shallowRef(LayoutDefault)
        const route = useRoute()
        watch(
            () => route.meta,
            async meta => {

                try {
                    const component = await import(/* webpackChunkName: "[request]", webpackPrefetch: true */`@/components/Layout/${meta.layout}.vue`);
                    layout.value = component?.default || LayoutDefault

                } catch (e) {
                    console.warn(`${e} Default is loaded...`)
                    layout.value = LayoutDefault
                }
            },
            { immediate: true }
        )
        return { layout }
    }
}
</script>
